import graphql from "babel-plugin-relay/macro";

export const allNetworksDropdown = graphql`
    fragment NetworkFragments_allNetworkDropdown on Network @relay(plural: true) {
        id
        name
    } 
`